const React = require('react')
const PropTypes = require('prop-types')
const withStyles = require('withStyles').default
const styles = require('./cards.less')

const card_list = [
    {
        icon: 'aboutme',
        description: (
            <span>
                Create a page to present who you are and what you do in one&nbsp;link.
            </span>
        ),
        variant_description: {
            from_profile: (
                <span>
                    Freelancers and entrepreneurs use about.me to grow their audience and get new clients.
                </span>
            ),
        },
    },
    {
        icon: 'professional',
        title: 'Professional',
        description: (
            <span>
                Take control and centralize your online&nbsp;presence.
            </span>
        ),
    },
    {
        icon: 'authentic',
        title: 'Authentic',
        description: (
            <span>
                Showcase all of you&mdash;from your work to your&nbsp;passions.
            </span>
        ),
    },
    {
        icon: 'simple',
        title: 'Simple',
        description: (
            <span>
                Easy for your audience to learn about you, simple for you to set&nbsp;up.
            </span>
        ),
    },
]

function CardItem(props) {
    const { item, variant } = props
    const { icon, title, description, variant_description } = item

    const display_description = (
        // check that we've been given a variant
        variant
        // check that the card has a variant_description object
        && variant_description
        // check that there is an entry in there for this variant
        && variant_description[variant]
        // else just use the default description
        || description
    )

    return (
        <li className={icon}>
            <div className="icon"></div>
            <div className="text-wrapper">
                {title &&
                    <p className="title">{title}</p>
                }
                <p className="description">{display_description}</p>
            </div>
        </li>
    )
}
CardItem.propTypes = {
    item: PropTypes.object.isRequired,
    variant: PropTypes.string,
}

function Cards(props) {
    const { variant } = props

    return (
        <ul className={styles.scope}>
            {card_list.map((item, i) => {
                return (
                    <CardItem key={i} item={item} variant={variant} />
                )
            })}
        </ul>
    )
}

Cards.propTypes = {
    variant: PropTypes.string,
}

module.exports = withStyles(styles)(Cards)
